module.exports = "<div class=\"konami\"></div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/konami/sample.html
// module id = 73
// module chunks = 0